import httpClient from './httpClient';
import {handleError} from '../utils/errorHandling';

interface PublicationItem {
  readonly abbreviation: string;
}

export class PublicationItemsCacheService<T extends PublicationItem> {
  private cache: Map<string, T[]> = new Map();
  private endpoint: string;
  private errorMessage: string;

  constructor(endpoint: string, errorMessage: string) {
    this.endpoint = endpoint;
    this.errorMessage = errorMessage;
  }

  public async getItemsForPublication(publicationId: string): Promise<T[]> {
    if (this.cache.has(publicationId)) {
      return this.cache.get(publicationId)!;
    }

    const items = await handleError(
      () => httpClient.get<T[]>(`${this.endpoint}/by-publication/${publicationId}`),
      this.errorMessage,
      () => []
    );

    this.cache.set(publicationId, items);
    return items;
  }

  public getItemByAbbreviation(publicationId: string, abbreviation: string): T | undefined {
    const items = this.cache.get(publicationId);
    if (!items) {
      return undefined;
    }

    return items.find(item => item.abbreviation === abbreviation);
  }

  public clearCache(): void {
    this.cache.clear();
  }
}

